import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { ConnectorConfigsCard } from "./card";
import { ConnectorConfigsNew } from "./new";
import { ConnectorConfigsTable } from "./table";

export default function ConnectorConfigs() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Connector configurations");
  }, []);

  return (
    <Routes>
      <Route index element={<ConnectorConfigsTable />} />
      <Route path="/new" element={<ConnectorConfigsNew />} />
      <Route path=":id" element={<ConnectorConfigsCard />} />
    </Routes>
  );
}
